import { useFormikContext } from 'formik';
import { Button, ButtonProps } from 'yoso';
import { EvolveValues } from '~/components/Evolve/Form/EvolveForm.hooks';
import { T } from '~/components/I18n';

export type EvolveFormButtonProps = ButtonProps;

export const EvolveFormButton = ({
  className,
  children = <T name="citizen_evolve_unit_button" />,
  ...props
}: EvolveFormButtonProps) => {
  const { isValid, isSubmitting } = useFormikContext<EvolveValues>();
  return (
    <Button
      type="submit"
      color="primary"
      disabled={!isValid || isSubmitting}
      className={className}
      {...props}>
      {children}
    </Button>
  );
};
